import {
    IAllocation,
    IAllocationSearchParameters,
} from '@/interfaces/allocation';
import { createModule, mutation, action } from 'vuex-class-component';
import { ws } from '@/wapi/ws';
import { config, filter } from 'vue/types/umd';
import baseAjaxCall from '@/tools/ajax-wrapper';

const VuexModule = createModule({
    namespaced: 'allocations',
    strict: true,
});

export class AllocationsStore extends VuexModule {
    private availableAllocations: IAllocation[] = [];
    private searchParameters: IAllocationSearchParameters | null = null;
    private fromOptions: string = '';
    private toOptions: string = '';
    private carrierOptions: string = '';
    private clientOptions: string = '';
    private lastRefreshDate: string = '';
    private selectedWeekOffset: any = {};

    get allocations() {
        return this.availableAllocations;
    }

    get parameters() {
        return this.searchParameters;
    }

    get fromField() {
        return this.fromOptions;
    }

    get toField() {
        return this.toOptions;
    }

    get carrierField() {
        return this.carrierOptions;
    }

    get clientField() {
        return this.clientOptions;
    }

    get refreshDate() {
        return this.lastRefreshDate;
    }

    get WeekOffset() {
        return this.selectedWeekOffset;
    }

    @action
    public async getFromToOptions() {
        const apiUrl = process.env.NODE_ENV === 'production' ? process.env.VUE_APP_API_URL_PRODUCTION : process.env.VUE_APP_API_URL_DEVELOPMENT;
        const url = `${apiUrl}/GetOriginsDestinations`;
        const response: any = await baseAjaxCall('get',url, (v) => v) ;
        // if (!response.ok) {
        //     throw new Error(response.statusText);
        // }
        // const raw_data = await (response.json());

        this.setFromOptions(response.datas.origins);
        this.setToOptions(response.datas.destinations);
    }

    @action
    public async getCarriersClients() {
        const apiUrl = process.env.NODE_ENV === 'production' ? process.env.VUE_APP_API_URL_PRODUCTION : process.env.VUE_APP_API_URL_DEVELOPMENT;
        const url = `${apiUrl}/GetCarriersClients`;
        const response: any = await baseAjaxCall('get',url, (v) => v) ;

        this.setCarrierOptions(response.datas.carriers);
        this.setClientOptions(response.datas.clients);
    }

    @action
    public async getLastRefreshDate() {
        const apiUrl = process.env.NODE_ENV === 'production' ? process.env.VUE_APP_API_URL_PRODUCTION : process.env.VUE_APP_API_URL_DEVELOPMENT;
        const url = `${apiUrl}/GetLastRefreshDate`;
        const response: any = await baseAjaxCall('get',url, (v) => v) ;
        this.setLastRefreshDate(response.datas);
    }

    @action
    public async search(searchParameters: IAllocationSearchParameters) {
        const response = await ws.searchAllocations(searchParameters);
        if (response !== null) {
            //const allocations = //ws.mockSearch(searchParameters);
            //response.result as IAllocation[];
            const allocations = response?.result as IAllocation[];

            // Filter according to shippingLine and client. Also remove allocations that have 0 as contract capacity
            const filtered_allocations: IAllocation[] = [];
            allocations.forEach(function (allocation) {
                if ((searchParameters.client?.includes(allocation.client) || searchParameters.client?.length == 0)
                    && (searchParameters.carrier?.includes(allocation.shippingLine) || (searchParameters.carrier?.length == 0))
                    && (allocation.contactCapacity != 0))
                    filtered_allocations.push(allocation);
            });
            this.setSearchParameters(searchParameters);
            this.setAvailableAllocations(filtered_allocations);
            this.setWeekWindowLayout({previousWeek: false, currentWeek: true, nextWeek: false});
        }
    }

    @mutation
    private setAvailableAllocations(allocations: IAllocation[]) {
        this.availableAllocations = allocations;
    }

    @mutation
    private setSearchParameters(searchParameters: IAllocationSearchParameters) {
        this.searchParameters = searchParameters;
    }

    @mutation
    private setFromOptions(fromOptions: string) {
        this.fromOptions = fromOptions;
    }

    @mutation
    private setToOptions(toOptions: string) {
        this.toOptions = toOptions;
    }
    @mutation
    private setCarrierOptions(carrierOptions: string) {
        this.carrierOptions = carrierOptions;
    }

    @mutation
    private setClientOptions(clientOptions: string) {
        this.clientOptions = clientOptions;
    }

    @mutation
    private setLastRefreshDate(lastRefreshDate: string)
    {
        this.lastRefreshDate = lastRefreshDate;
    }

    @mutation
    private setWeekWindowLayout(selectedWeekOffset: any)
    {
        this.selectedWeekOffset = selectedWeekOffset;
    }
}
